import { Link } from "@inertiajs/react";
import { Eye } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useRevoGridContext } from "@/contexts/revogrid-context";
import { organizationSupplierPath } from "@/routes";
import type { Supplier } from "@/types";

interface HasModel<T> {
  model: T;
}
const hasModel = <T,>(p: unknown): p is HasModel<T> =>
  typeof p === "object" &&
  p !== null &&
  "model" in (p as Record<string, unknown>);

export const SupplierActionsCell = (props: unknown) => {
  const { organizationSlug } = useRevoGridContext();

  let supplier: Supplier;
  if (hasModel<Supplier>(props)) {
    supplier = props.model;
  } else {
    supplier = props as Supplier;
  }

  return (
    <div className="flex justify-center items-center h-full">
      <Button variant="ghost" size="sm" asChild>
        <Link href={organizationSupplierPath(organizationSlug, supplier.id)}>
          <Eye className="h-4 w-4 mr-1" />
          Ver
        </Link>
      </Button>
    </div>
  );
};
